<template>

  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">{{$t('project-save.project-is[0]')}} {{$t('project-save.project-is[1]')}} {{ titleIsPrivate }} {{$t('project-save.project-is[2]')}}</div>
      </header>
      <section v-if="!$isEngCom" class="modal-card-body" :class="{'small-body': modalIsPrivate}" v-bind:style="{'min-height' : modalBodyHeight + 'px'}">
        <div  class="toggle">
          <span> {{ $t('private') }} </span>
          <toggle-switch :value="modalIsPrivate" :reverse="true" @input="modalIsPrivate = !modalIsPrivate"></toggle-switch>
          <span> &nbsp;{{ $t('public') }} </span>
        </div>
        <div class="modal-text">{{ copy }}</div>

        <div class="add-categories" v-if="(!modalIsPrivate || $isYSC) && missingCategories">
          <div v-if="!modalChosenCategories.length" class="add-title is-flex">{{ $t('project-save.min-category') }}</div>
          <div ref="categoryInput" class="cat-select" >
            <category-selector v-model="modalChosenCategories" :includeSubCategories="true" :isModal="true" @calculateBodyHeight="calculateBodyHeight"></category-selector>
          </div>
        </div>
      </section>
      <footer v-if="isPrivate || modalChosenCategories.length" class="modal-card-foot">
        <button @click="success" class="button success-button is-primary" :disabled="disabled">{{ $t('save') }}</button>
        <button @click="cancel" class="button cancel-button">{{ $t('cancel') }}</button>
      </footer>
      <button @click="cancel" class="delete close-button" aria-label="close"></button>
    </div>
  </div>

</template>

<script>
import i18n from '@/i18n'
import ToggleSwitch from '@/components/Controls/ToggleSwitch'
import componentState from '@/mixins/component-state'
import CategorySelector from '@/components/Inputs/CategorySelector'

const copy = '- ' + i18n.t('project-save.canUpdateLater')
export default {
  props: ['isPrivate', 'chosenCategories'],
  components: {
    CategorySelector,
    ToggleSwitch
  },
  mixins: [componentState],
  data: function () {
    return {
      copy,
      modalIsPrivate: false,
      modalChosenCategories: [],
      missingCategories: false,
      modalBodyHeight: 200
    }
  },
  mounted: function () {
    this.modalIsPrivate = this.isPrivate
    this.modalChosenCategories = this.chosenCategories.slice() || []
    if (!this.modalChosenCategories.length) {
      this.missingCategories = true
    }
    this.calculateBodyHeight()
  },
  computed: {
    titleIsPrivate: function () {
      return this.modalIsPrivate ? i18n.t('project-save.private') : 'Public'
    },
    allCategories: function () {
      return this.$store.getters.categoriesLoaded ? this.$store.getters.sortedProjectCategories() : []
    },
    disabled: function () {
      return !this.modalIsPrivate && !this.modalChosenCategories.length
    }
  },
  methods: {
    success: function () {
      const data = { isPrivate: this.modalIsPrivate, chosenCategories: this.modalChosenCategories }
      this.$emit('save', data)
    },
    cancel: function () {
      this.$emit('cancel')
    },
    calculateBodyHeight: function () {
      if (this.$refs.categoryInput) {
        this.modalBodyHeight = this.$refs.categoryInput.offsetHeight + 190
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .close-button {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }
  .modal-card {
    overflow: visible;
  }
  .modal-card-body {
    padding: 0.5rem;
  }
  .cat-select {
    position: absolute;
    z-index: 10;
    padding-top: 10px;
    padding-right: 10px;
  }
  .btn-flex-end {
    justify-content: flex-end;
  }
  .modal-text {
    display: inline-block;
  }
  .toggle {
    margin: 1rem 0;
    display: inline-block;
  }
  .categories {
    flex-wrap: wrap;
    justify-content: center;
  }
  .add-categories {
    .tag {
        font-size: 0.8rem;
      color: white;
      border-radius: 0;
      margin-right: 0.65rem;
      margin-bottom: 0.65em;
      @include mobile {
        margin-right: 0.35rem;
        margin-bottom: 0.35rem;
      }
    }
  }
  .add-title {
    width: 100%;
  }
  .chosen-categories {
    margin-bottom: 1rem;
    .remove-cat {
      margin-left: 0.5rem;
      margin-top: 1rem;
    }
  }
</style>
